// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/styles/border.css'
import '@/assets/styles/reset.css'
import './directive/showTips'
import './directive/loadMore'
import "@/assets/styles/font.css"
import '@vant/touch-emulator';
import * as commonUtils from '@/utils'
import { Toast } from 'vant';
import {multipleHasEllipsis} from "./utils";
Vue.prototype.$commonUtils = commonUtils
Vue.prototype.$Toast = Toast
Vue.use(require('vue-wechat-title'));
Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(Vuex)
Vue.use(router)

Vue.directive('ellipsis',{
  inserted: function (el, binding) {// 指令的定义
    if(commonUtils.multipleHasEllipsis(el)){
      console.log();
      el.style.position='relative'
      let Div=document.createElement('div')
      Div.style.position='absolute'
      Div.style.bottom='0'
      Div.style.right='0'
      Div.innerHTML='...'
      Div.style.height=el.offsetHeight / binding.value+'px'
      Div.style.background='#fff'
      el.appendChild(Div)
    }
  },
  bind:function(){
    //这个指令的逻辑
    //可以利用this.el来获取到当前指令所在的元素对象
    this.el.style.color = 'red';
  }
});
localStorage.setItem('libraryName','islgd')

sessionStorage.removeItem("redirect")
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js